
/**
 * 미디어 또는 자료 타입
 */
export type UploadEduMediaBodyType = typeof UploadEduMediaBodyType[keyof typeof UploadEduMediaBodyType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UploadEduMediaBodyType = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  IMAGE: 'IMAGE',
  MARKDOWN: 'MARKDOWN',
  PDF: 'PDF',
  ZIP: 'ZIP',
  PRESENTATION: 'PRESENTATION',
  SPREADSHEET: 'SPREADSHEET',
  OTHER_ASSET: 'OTHER_ASSET',
} as const;
